// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DescriptionModal-descriptionModalInfoHeading-p9Sus {
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    color: var(--primary-foreground);
    margin-bottom: 6px;
}

.DescriptionModal-descriptionModalInfoDesc-dhlWF {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: var(--primary-foreground);
    margin-bottom: 0;
}

.DescriptionModal-descriptionModalInfoBtnContainer-lEAad {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    margin-top: 36px;
}`, "",{"version":3,"sources":["webpack://./src/components/DescriptionModal/DescriptionModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,qBAAyB;QAAzB,kBAAyB;YAAzB,yBAAyB;IACzB,gBAAgB;AACpB","sourcesContent":[".descriptionModalInfoHeading {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 28px;\n    color: var(--primary-foreground);\n    margin-bottom: 6px;\n}\n\n.descriptionModalInfoDesc {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    color: var(--primary-foreground);\n    margin-bottom: 0;\n}\n\n.descriptionModalInfoBtnContainer {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-top: 36px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"descriptionModalInfoHeading": `DescriptionModal-descriptionModalInfoHeading-p9Sus`,
	"descriptionModalInfoDesc": `DescriptionModal-descriptionModalInfoDesc-dhlWF`,
	"descriptionModalInfoBtnContainer": `DescriptionModal-descriptionModalInfoBtnContainer-lEAad`
};
module.exports = ___CSS_LOADER_EXPORT___;
